import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Button,
	Col,
	Card,
	CardBody,
	CardTitle,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../components/Common/withRouter"
import CampaignMetafieldsEditForm from "./CampaignMetafieldsEditForm";

// Utilities
import {
	createNotificationHelpers,
	getCampaignMetafields,
	updateCampaignMetafields,
} from "../utils";

class CampaignMetafields extends Component {
	constructor(props) {
		super(props)
		this.state = {
			store_domain: "",
			loading: false,
			store_status: "",
			jsonError: "",
			metafields: {
				block: {
					show_cart: false,
					cart_bubble: '#cart-icon-bubble',
					product: {
						regular: ".price__regular .price-item.price-item--regular, .product-block--price .product__price--compare",
						sale: ".price__sale .price-item.price-item--sale, .product-block--price .on-sale, .product-block--price [data-product-price]",
						compare: ".price__sale .price-item.price-item--regular, .product-block--price .product__price-savings "
					},
					collection: {
						grid: ".card__content .card__information",
						regular: ".price__regular .price-item.price-item--regular, .grid-product__price .grid-product__price--original",
						sale: ".price__sale .price-item.price-item--sale, .grid-product__price .grid-product__price--sale",
						compare: ".price__sale .price-item.price-item--regular",
					},
					cart: {
						price: ".cart-item .cart-item__details .cart-item__discounted-prices, .cart-item .cart-item__details div.product-option, .cart__price [data-cart-item-regular-price-group] [data-cart-item-regular-price]",
						total: ".cart-item .cart-item__totals .cart-item__discounted-prices,cart-item .cart-item__totals.small-hide .price.price-end, .cart__final-price [data-cart-item-final-price-group] [data-cart-item-final-price]",
						subtotal: ".totals .totals__subtotal-value, .cart-subtotal__price[data-cart-subtotal]",
					},
					drawer: {
						price: ".cart-item .cart-item__details .cart-item__discounted-prices, .cart-item .cart-item__details div.product-option, .cart__price [data-cart-item-regular-price-group] [data-cart-item-regular-price]",
						total: ".cart-item .cart-item__totals .cart-item__discounted-prices, .cart-item .cart-item__totals .price.price--end, .cart__final-price [data-cart-item-final-price-group] [data-cart-item-final-price]",
						subtotal: ".totals .totals__subtotal-value, .cart-subtotal__price[data-cart-subtotal]",
					}
				}
			}
		}

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}
	componentDidMount() {
		const locationState = this.props.location?.state;
		const data = locationState?.data || this.props.location?.data;
		if (data && data.store_domain) {
			const { store_domain, store_details, store_status } = data;
			this.setState({
				store_domain,
				store_details: { ...store_details },
				store_status
			});
			this.getMetafields(store_domain);
			return;
		}
		const params = new URLSearchParams(this.props.location?.search || '');
		const store = params.get('store');
		if (store) {
			this.setState({ store_domain: store });
			this.getMetafields(store);
			return;
		}
		return window.location.href = '/stores';
	}

	/**
	 * Loads metafields from API
	 */
	getMetafields = async (store_domain) => {
		const data = await getCampaignMetafields(store_domain, this.notify_error);

		if (data && Object.keys(data).length > 0) {
			this.setState({
				metafields: {
					block: data
				}
			});
		}
	}

	/**
	 * Handles form submission
	 */
	handleValidSubmit = async (e) => {
		e.preventDefault();
		const { store_domain, metafields, jsonError } = this.state;

		if (jsonError) {
			this.notify_error("JSON Error: Please fix JSON syntax errors before saving");
			return;
		}

		const success = await updateCampaignMetafields(
			store_domain,
			metafields,
			this.notify_error
		);

		if (success) {
			this.setState({ loading: true });
			this.notify_success("Metafields has been updated successfully!");
		}
	}

	/**
	 * Handles JSON changes from JsonEditor
	 */
	handleJsonChange = (jsonData) => {
		try {
			const parsedJson = JSON.parse(jsonData);
			this.setState({
				metafields: parsedJson,
				jsonError: ''
			});
		} catch (error) {
			this.setState({
				jsonError: 'Error parsing JSON. Please check the JSON syntax and try again.'
			});
		}
	};
	render() {
		const { jsonError, store_domain, metafields, loading, store_details, store_status } = this.state;

		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Metafields Edit</title>
					</Helmet>
					<Container fluid>
						<Breadcrumbs
							title={("Metafields Edit")}
							breadcrumbItem={("Edit Metafields")}
						/>
						<ToastContainer />
						<Col md={12}>
							<Card>
								<CardBody>
									<CardTitle className="h4"></CardTitle>
									<Link to={{ pathname: "/merchant-details", search: this.state.store_domain ? `?store=${encodeURIComponent(this.state.store_domain)}` : undefined, state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain: this.state.store_domain }, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
										<Button className="btn btn-dark">
											<i className="fa fa-arrow-left"></i> Store Details
										</Button>
									</Link>
									<CampaignMetafieldsEditForm
										store_domain={store_domain}
										metafields={metafields}
										jsonError={jsonError}
										onJsonChange={this.handleJsonChange}
										onSubmit={this.handleValidSubmit}
									/>
								</CardBody>
							</Card>
						</Col>
					</Container>
				</div>
			</React.Fragment>
		)
	}
}

CampaignMetafields.propTypes = {
	t: PropTypes.any
}
export default withRouter(CampaignMetafields)
